const LocationReviewsData = [
  {
    "customer": "Michael S.",
    "review": "Exceptional service! The locksmith arrived quickly, rekeyed my locks, and ensured everything was secure.",
    "service": "Lock Rekeying"
  },
  {
    "customer": "Jessica T.",
    "review": "Master Locksmith exceeded my expectations. They replaced my old locks with high-quality ones. Highly recommend!",
    "service": "Lock Replacement"
  },
  {
    "customer": "Emily R.",
    "review": "Great experience from start to finish. The locksmith explained the process and ensured my home was secure.",
    "service": "Lock Installation"
  },
  {
    "customer": "Anthony J.",
    "review": "Efficient, professional, and reliable. The locksmith fixed my jammed lock in no time.",
    "service": "Lock Repair"
  },
  {
    "customer": "Robert K.",
    "review": "Quick response time and thorough lock installation. I feel much safer now.",
    "service": "Lock Installation"
  },
  {
    "customer": "Sarah P.",
    "review": "They did an amazing job rekeying my locks. The locksmith was friendly and very professional.",
    "service": "Lock Rekeying"
  },
  {
    "customer": "Lisa M.",
    "review": "Very impressed with the service. The locksmith was polite and replaced my locks efficiently.",
    "service": "Lock Replacement"
  },
  {
    "customer": "Kevin H.",
    "review": "Master Locksmith provided excellent service, securing all my doors quickly.",
    "service": "Lock Installation"
  },
  {
    "customer": "Diana F.",
    "review": "This was my first time using them, and I’ll definitely call again. Great value and fantastic results.",
    "service": "Emergency Locksmith Service"
  },
  {
    "customer": "Eric W.",
    "review": "The locksmiths were professional and replaced my broken lock in no time. Very satisfied.",
    "service": "Lock Repair"
  },
  {
    "customer": "Samantha L.",
    "review": "The team did a fantastic job unlocking my car door. Quick and efficient service!",
    "service": "Car Lockout"
  },
  {
    "customer": "Tom C.",
    "review": "Master Locksmith saved me when I was locked out. The locksmith was prompt and very professional.",
    "service": "Home Lockout"
  },
  {
    "customer": "Olivia N.",
    "review": "Highly recommend their locksmith service. They arrived on time and resolved my issue quickly.",
    "service": "Emergency Locksmith Service"
  },
  {
    "customer": "Jason B.",
    "review": "I could tell they knew exactly what they were doing. My new locks work perfectly!",
    "service": "Lock Replacement"
  },
  {
    "customer": "Maria S.",
    "review": "Master Locksmith did an amazing job installing a high-security lock. I feel much safer now!",
    "service": "High-Security Lock Installation"
  },
  {
    "customer": "Peter V.",
    "review": "Quick, efficient, and friendly service. I’ll definitely use them again for locksmith needs.",
    "service": "Lock Rekeying"
  },
  {
    "customer": "Vanessa D.",
    "review": "Outstanding service! The locksmiths explained the benefits of the new lock and installed it perfectly.",
    "service": "Lock Installation"
  },
  {
    "customer": "Ben A.",
    "review": "I had a broken lock, but Master Locksmith handled it well. Great job!",
    "service": "Lock Repair"
  },
  {
    "customer": "Amy G.",
    "review": "They were able to schedule me quickly and rekeyed my locks thoroughly. I appreciate their attention to detail.",
    "service": "Lock Rekeying"
  },
  {
    "customer": "Rachel K.",
    "review": "Very pleased with the locksmith service. They made sure all my locks were secure.",
    "service": "Lock Inspection"
  },
  {
    "customer": "Alex P.",
    "review": "The team found and fixed a problem with my door lock that I didn't even notice. Great service!",
    "service": "Lock Repair"
  },
  {
    "customer": "Brandon L.",
    "review": "Had a lock repair done, and they did an excellent job. My lock works like new.",
    "service": "Lock Repair"
  },
  {
    "customer": "Nina J.",
    "review": "They quickly fixed the issue with my lock. I’m very happy with the results.",
    "service": "Lock Repair"
  },
  {
    "customer": "Trevor M.",
    "review": "Master Locksmith repaired a damaged lock. It’s working much better now, and I’m very satisfied.",
    "service": "Lock Repair"
  },
  {
    "customer": "Katie W.",
    "review": "The locksmith was able to repair my lock and improve my home's security. Highly recommend.",
    "service": "Lock Repair"
  },
  {
    "customer": "Chris B.",
    "review": "The locksmiths did a thorough inspection and fixed the problem quickly. Great job!",
    "service": "Lock Repair"
  },
  {
    "customer": "Megan R.",
    "review": "Very satisfied with their service. They repaired a lock and ensured it was secure.",
    "service": "Lock Repair"
  },
  {
    "customer": "Danny H.",
    "review": "The repair work on my lock was quick, and the results were excellent. I appreciate their professionalism.",
    "service": "Lock Repair"
  },
  {
    "customer": "Lauren T.",
    "review": "Master Locksmith did a wonderful job replacing my locks. I feel much safer.",
    "service": "Lock Replacement"
  },
  {
    "customer": "Rick A.",
    "review": "They replaced my old locks with high-security ones. I’m very pleased with their service.",
    "service": "High-Security Lock Installation"
  },
  {
    "customer": "Ashley E.",
    "review": "The locksmiths were professional and repaired the lock efficiently. My home feels more secure now.",
    "service": "Lock Repair"
  },
  {
    "customer": "Monica G.",
    "review": "The team was able to fix a faulty lock that was affecting my door. Great job!",
    "service": "Lock Repair"
  },
  {
    "customer": "Hank F.",
    "review": "I was impressed by their thorough inspection and repair work. They really know what they're doing.",
    "service": "Lock Repair"
  },
  {
    "customer": "Jasmine K.",
    "review": "Master Locksmith repaired my locks and also replaced some outdated ones. The service was fantastic!",
    "service": "Lock Repair"
  }
];

export default LocationReviewsData;
